import React from "react";
import { cn } from "@/lib/utils";

export const initialsOf = (name?: string | null) =>
  (name || "")
    .split(" ")
    .filter(Boolean)
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase() || "?";

/** Round initials badge followed by a name; used for owners in tables */
export function Person({ name, className }: { name?: string | null; className?: string }) {
  if (!name) return <span className="text-muted-foreground">Unassigned</span>;
  return (
    <span className={cn("inline-flex items-center gap-1.5 whitespace-nowrap", className)}>
      <span className="flex size-[22px] items-center justify-center rounded-full bg-accent text-[9.5px] font-bold text-accent-foreground">{initialsOf(name)}</span>
      {name}
    </span>
  );
}

/** Initials only, for tight spaces such as board cards */
export function PersonDot({ name, className }: { name?: string | null; className?: string }) {
  return (
    <span title={name || "Unassigned"} className={cn("flex size-5 items-center justify-center rounded-full bg-accent text-[9px] font-bold text-accent-foreground", className)}>
      {initialsOf(name)}
    </span>
  );
}
